import { Position, Toaster } from "@blueprintjs/core";
 
const Toast = Toaster.create({
  position: Position.TOP,
});

export default Toast;